var _rect, _path, _circle, _rect2, _path2, _circle2, _rect3, _path3, _circle3, _rect4, _path4, _rect5, _path5, _rect6, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersistenceWalking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 137,
    viewBox: "0 0 273 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 36,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#4375D7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6135 70.6637C36.5932 70.7773 37.4652 71.3694 37.5747 71.4748C37.7716 71.6831 37.9533 71.9054 38.1181 72.1399C38.6332 72.7402 39.3064 73.239 39.8499 73.8149C40.5584 74.5006 41.1116 75.3304 41.4721 76.2482C41.61 76.6538 41.6019 77.0918 41.7073 77.5217C41.8411 78.0529 41.9871 78.5802 42.1129 79.1074C42.3805 80.0767 42.6036 81.0581 42.8145 82.0396C42.997 82.8872 43.4107 83.97 43.2606 84.8379C43.2002 85.1482 43.0729 85.4416 42.8875 85.6977C42.694 85.9981 42.4347 86.2506 42.1291 86.4358C41.318 86.9225 39.6511 86.7643 39.0955 85.9248C38.8896 85.582 38.7365 85.2101 38.6413 84.8217C38.3209 83.747 38.037 82.6682 37.7856 81.5772C37.5585 80.5917 37.4571 79.5494 37.1813 78.5842C36.7271 77.0512 35.3887 76.305 34.4884 75.1045C34.2731 74.7313 33.9348 74.4446 33.5313 74.2934C33.7706 76.3902 32.8135 78.422 31.8847 80.3159C31.3737 81.3542 30.8627 82.3924 30.2828 83.3941C29.7984 84.3339 29.2411 85.2343 28.616 86.087C28.4308 86.3446 28.1998 86.5659 27.9346 86.74C26.4949 87.5267 24.9457 86.2776 24.9132 84.7973C24.8889 83.7875 25.4161 82.9764 25.8541 82.1004L27.2655 79.2615C27.7658 78.3015 28.2126 77.3144 28.6038 76.305C28.89 75.3778 29.0976 74.4281 29.2243 73.4661C29.6298 71.2923 29.934 69.1348 30.2098 66.9407L30.6154 63.5989C29.8042 64.1951 29.3622 64.9575 28.835 65.7849C28.255 66.6974 27.594 67.5288 26.9329 68.3723C26.8459 68.493 26.7452 68.6033 26.6328 68.7008C26.065 69.1388 25.0106 68.9644 24.4874 68.5548C24.3037 68.3968 24.1577 68.1997 24.0602 67.978C23.9626 67.7562 23.916 67.5154 23.9237 67.2733C23.9454 66.7849 24.0582 66.3048 24.2562 65.8579C25.6676 62.2849 28.5227 60.0138 31.8847 58.3916C32.1584 58.2513 32.4416 58.1307 32.7323 58.0306C33.0552 57.9382 33.3869 57.8797 33.7219 57.8562C34.3015 57.8109 34.884 57.8204 35.4617 57.8846C36.358 57.986 37.2868 58.0793 37.964 58.6714C38.5965 59.3046 39.1632 60.0003 39.6552 60.7478C40.8289 62.2982 42.3263 63.5743 44.0433 64.4871C44.8058 64.8926 45.6655 65.2982 45.9697 66.1093C46.2739 66.9204 45.7102 67.9546 44.895 68.3358C43.4512 69.009 41.6262 67.6504 40.4744 66.8312C40.0455 66.5045 39.6365 66.1524 39.2496 65.7767C39.0469 65.5902 37.9032 64.7872 37.9032 64.5601C37.2705 66.3445 36.942 68.786 36.6135 70.6637Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.887,
    cy: 52.7747,
    r: 3.85279,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 36,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#4375D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132.614 70.6637C132.593 70.7773 133.465 71.3694 133.575 71.4748C133.772 71.6831 133.953 71.9054 134.118 72.1399C134.633 72.7402 135.306 73.239 135.85 73.8149C136.558 74.5006 137.112 75.3304 137.472 76.2482C137.61 76.6538 137.602 77.0918 137.707 77.5217C137.841 78.0529 137.987 78.5802 138.113 79.1074C138.381 80.0767 138.604 81.0581 138.814 82.0396C138.997 82.8872 139.411 83.97 139.261 84.8379C139.2 85.1482 139.073 85.4416 138.887 85.6977C138.694 85.9981 138.435 86.2506 138.129 86.4358C137.318 86.9225 135.651 86.7643 135.096 85.9248C134.89 85.582 134.736 85.2101 134.641 84.8217C134.321 83.747 134.037 82.6682 133.786 81.5772C133.558 80.5917 133.457 79.5494 133.181 78.5842C132.727 77.0512 131.389 76.305 130.488 75.1045C130.273 74.7313 129.935 74.4446 129.531 74.2934C129.771 76.3902 128.813 78.422 127.885 80.3159C127.374 81.3542 126.863 82.3924 126.283 83.3941C125.798 84.3339 125.241 85.2343 124.616 86.087C124.431 86.3446 124.2 86.5659 123.935 86.74C122.495 87.5267 120.946 86.2776 120.913 84.7973C120.889 83.7875 121.416 82.9764 121.854 82.1004L123.265 79.2615C123.766 78.3015 124.213 77.3144 124.604 76.305C124.89 75.3778 125.098 74.4281 125.224 73.4661C125.63 71.2923 125.934 69.1348 126.21 66.9407L126.615 63.5989C125.804 64.1951 125.362 64.9575 124.835 65.7849C124.255 66.6974 123.594 67.5288 122.933 68.3723C122.846 68.493 122.745 68.6033 122.633 68.7008C122.065 69.1388 121.011 68.9644 120.487 68.5548C120.304 68.3968 120.158 68.1997 120.06 67.978C119.963 67.7562 119.916 67.5154 119.924 67.2733C119.945 66.7849 120.058 66.3048 120.256 65.8579C121.668 62.2849 124.523 60.0138 127.885 58.3916C128.158 58.2513 128.442 58.1307 128.732 58.0306C129.055 57.9382 129.387 57.8797 129.722 57.8562C130.301 57.8109 130.884 57.8204 131.462 57.8846C132.358 57.986 133.287 58.0793 133.964 58.6714C134.597 59.3046 135.163 60.0003 135.655 60.7478C136.829 62.2982 138.326 63.5743 140.043 64.4871C140.806 64.8926 141.666 65.2982 141.97 66.1093C142.274 66.9204 141.71 67.9546 140.895 68.3358C139.451 69.009 137.626 67.6504 136.474 66.8312C136.045 66.5045 135.636 66.1524 135.25 65.7767C135.047 65.5902 133.903 64.7872 133.903 64.5601C133.271 66.3445 132.942 68.786 132.614 70.6637Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.887,
    cy: 52.7747,
    r: 3.85279,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 187,
    y: 28,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#4375D7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M229.017 71.3316C228.991 71.4735 230.081 72.2137 230.218 72.3455C230.464 72.6059 230.691 72.8837 230.897 73.1769C231.541 73.9271 232.383 74.5507 233.062 75.2705C233.948 76.1278 234.639 77.165 235.09 78.3122C235.262 78.8192 235.252 79.3667 235.384 79.904C235.551 80.5681 235.734 81.2272 235.891 81.8862C236.225 83.0978 236.504 84.3246 236.768 85.5514C236.996 86.6109 237.513 87.9645 237.325 89.0493C237.25 89.4372 237.091 89.804 236.859 90.1241C236.617 90.4996 236.293 90.8151 235.911 91.0467C234.897 91.655 232.814 91.4573 232.119 90.4079C231.862 89.9794 231.67 89.5146 231.551 89.029C231.151 87.6856 230.796 86.3372 230.482 84.9735C230.198 83.7416 230.071 82.4388 229.726 81.2322C229.159 79.316 227.486 78.3832 226.36 76.8826C226.091 76.4161 225.668 76.0577 225.164 75.8687C225.463 78.4896 224.267 81.0294 223.106 83.3969C222.467 84.6947 221.828 85.9924 221.103 87.2446C220.498 88.4194 219.801 89.5449 219.02 90.6107C218.788 90.9327 218.5 91.2093 218.168 91.4269C216.368 92.4104 214.432 90.849 214.391 88.9986C214.361 87.7363 215.02 86.7224 215.567 85.6274L217.332 82.0788C217.957 80.8788 218.516 79.645 219.004 78.3832C219.362 77.2242 219.622 76.0371 219.78 74.8346C220.287 72.1173 220.667 69.4204 221.012 66.6778L221.519 62.5006C220.505 63.2458 219.952 64.1989 219.293 65.233C218.569 66.3737 217.742 67.4129 216.916 68.4673C216.807 68.6182 216.681 68.756 216.541 68.878C215.831 69.4255 214.513 69.2075 213.859 68.6955C213.629 68.498 213.447 68.2516 213.325 67.9744C213.203 67.6972 213.145 67.3962 213.154 67.0935C213.182 66.483 213.323 65.883 213.57 65.3243C215.334 60.8581 218.903 58.0192 223.106 55.9914C223.448 55.8161 223.802 55.6653 224.165 55.5402C224.569 55.4247 224.983 55.3516 225.402 55.3222C226.127 55.2656 226.855 55.2775 227.577 55.3577C228.697 55.4845 229.858 55.6011 230.705 56.3412C231.495 57.1327 232.204 58.0023 232.819 58.9368C234.286 60.8748 236.158 62.4698 238.304 63.6108C239.257 64.1177 240.332 64.6247 240.712 65.6386C241.092 66.6525 240.387 67.9452 239.368 68.4217C237.564 69.2632 235.283 67.565 233.843 66.5409C233.307 66.1326 232.795 65.6924 232.312 65.2229C232.058 64.9897 230.629 63.9859 230.629 63.702C229.838 65.9326 229.427 68.9844 229.017 71.3316Z",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 228.108,
    cy: 48.9703,
    r: 4.81598,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 82,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M155.5 98L159.5 102L166.5 94",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 82,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5 98L63.5 102L70.5 94",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 241,
    y: 82,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 257,
    cy: 98,
    r: 2,
    fill: "#24284E"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 98,
    r: 2,
    fill: "#24284E"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 98,
    r: 2,
    fill: "#24284E"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 132,
    r: 2,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 83,
    cy: 23,
    r: 2,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 132.5,
    r: 1.5,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 8.5,
    r: 1.5,
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 137.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.5,
    cy: 120.5,
    r: 1.5,
    fill: "white"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 213.5,
    cy: 135.5,
    r: 1.5,
    fill: "white"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 203.5,
    cy: 4.5,
    r: 1.5,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M249.5 18L254 8",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M197.5 115.5L187.5 128",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M237.5 123L239.5 131",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M179.5 21.5L188 28.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersistenceWalking);
export default __webpack_public_path__ + "static/media/persistence-walking.e0c34684635e9384bf4ca6cd42c750ca.svg";
export { ForwardRef as ReactComponent };